import { render } from "./FolderFilesView.vue?vue&type=template&id=8734143e&scoped=true"
import script from "./FolderFilesView.vue?vue&type=script&lang=js"
export * from "./FolderFilesView.vue?vue&type=script&lang=js"

import "./FolderFilesView.vue?vue&type=style&index=0&id=8734143e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8734143e"]])

export default __exports__